const urlForBreadCrumb = new URL(window.location.href);
const paramsForBreadCrumb = urlForBreadCrumb.searchParams;
const prefectureParamForBreadCrumb = paramsForBreadCrumb.get("prefecture");
const keywordParamForBreadCrumb = paramsForBreadCrumb.get("keyword");
const breadcrumbWrapper = document.getElementById("breadcrumbWrapper");

// 商品一覧
const mainCollectionPageWidthPc = document.getElementById(
  "mainCollectionPageWidthPc"
);
const mainCollectionPageWidthSp = document.getElementById(
  "mainCollectionPageWidthSp"
);
// 検索後商品一覧
const searchPageWidthPc = document.getElementsByClassName(
  "search-page-width-pc"
)[0];
const searchPageWidthSp = document.getElementsByClassName(
  "search-page-width-sp"
)[0];
// 商品詳細
const mainProductContainer = document.getElementById("mainProductContainer");
// カート
const cartFooter = document.getElementsByClassName("cart__footer")[0];
const cartWarning = document.getElementsByClassName("cart__warnings")[0];
// マイページ
const customerTitle = document.getElementsByClassName("customer__title")[0];
const chakraContainer = document.getElementsByClassName("chakra-container")[0];
// よくある質問
const faqContainer = document.getElementsByClassName(
  "faq-plus-app-container-featured-faqs"
)[0];

const pageWidthArray = [
  mainCollectionPageWidthPc,
  mainCollectionPageWidthSp,
  mainProductContainer,
  searchPageWidthPc,
  searchPageWidthSp,
  cartFooter,
  cartWarning,
  customerTitle,
  chakraContainer,
  faqContainer,
];

pageWidthArray.map((ele) => {
  if (ele && ele.clientWidth != 0) {
    const eleWidth = ele.clientWidth;

    if (ele == chakraContainer) {
      breadcrumbWrapper.classList.add("css-1br47j2");
      breadcrumbWrapper.style.width = "100%";
    } else {
      breadcrumbWrapper.style.width = `${eleWidth}px`;
    }
  }
});

const breadCrumbShopListDetail = document.getElementById(
  "breadCrumbShopListDetail"
);
if (prefectureParamForBreadCrumb && prefectureParamForBreadCrumb != "") {
  breadCrumbShopListDetail.innerHTML = `${prefectureParamForBreadCrumb}の店舗一覧`;
}
if (keywordParamForBreadCrumb && prefectureParamForBreadCrumb != "") {
  breadCrumbShopListDetail.innerHTML = `${keywordParamForBreadCrumb}の店舗一覧`;
}
if (urlForBreadCrumb.pathname == "/apps/floor-s") {
  const breadcrumbArrow = document.createElement("span");
  breadcrumbArrow.innerHTML = "&gt;";
  breadcrumbArrow.classList.add("breadcrumb-arrow");
  breadcrumbWrapper.appendChild(breadcrumbArrow);

  const linkForMikawayaSubs = document.createElement("a");
  linkForMikawayaSubs.href = "/account";
  linkForMikawayaSubs.innerHTML = "マイページ";
  breadcrumbWrapper.appendChild(linkForMikawayaSubs);
}
if (urlForBreadCrumb.pathname == "/a/faq") {
  const breadcrumbArrow = document.createElement("span");
  breadcrumbArrow.innerHTML = "&gt;";
  breadcrumbArrow.classList.add("breadcrumb-arrow");
  breadcrumbWrapper.appendChild(breadcrumbArrow);

  const linkForFaq = document.createElement("span");
  linkForFaq.innerHTML = "よくあるご質問";
  breadcrumbWrapper.appendChild(linkForFaq);
}
const collectionPath = urlForBreadCrumb.href;
const breadCrumbCollection = document.getElementById("breadCrumbCollection");
if (breadCrumbCollection && breadCrumbCollection != "") {
  breadCrumbCollection.href = collectionPath;
}
